import styled, { css } from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { IndicatorLayout } from "../consts/indicator-layout";
import { IndicatorDefaultBox } from "./indicator.box";

const IndicatorIconDefaultBox = styled.div<{active?: boolean, displayLayout?: IndicatorLayout}>`
    display: block;
    margin: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "0 1rem 0 0" : "1rem" };

    transition: opacity 0.2s ease;
    opacity: ${({displayLayout, active}) => displayLayout === IndicatorLayout.List ? (active ? "1" : "0.4") : "1" };
    ${IndicatorDefaultBox}:hover & {
        opacity: 1;
    }
    @media ${({theme}) => theme.mediaQuery.lowHeight}, ${({theme}) => theme.mediaQuery.xlAndBelow} {
        ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "" : css`
            margin: 0.5rem;
        `}
    }
`;

const IndicatorIconCasino777Box = styled(IndicatorIconDefaultBox)`

`;

const IndicatorIconHarrahsWsopBox = styled(IndicatorIconDefaultBox)`
`;

const IndicatorIconSIBox = styled(IndicatorIconDefaultBox)`
    position: relative;
`;


export const IndicatorIconBox = styledByTheme(IndicatorIconDefaultBox)
    .forCasino777(IndicatorIconCasino777Box)
    .forHarrahs(IndicatorIconHarrahsWsopBox)
    .forWsop(IndicatorIconHarrahsWsopBox)
    .forSI(IndicatorIconSIBox)
    .apply();
